import React from 'react';

export default (props) => {
  return (
    <React.Fragment>
      <h1 className="page-title">Privacy policy</h1>
      <ul>
        <li><a href="/">MyScan</a> is provided to you by Slough Borough Council, and has been developed by Looking Local
          Ltd.
        </li>
        <li>You can use MyScan to send evidence and personal data to Slough Borough Council. For example, you may need
          to send evidence to Slough Council to make a Housing Benefit claim.
        </li>
        <li>If you send evidence and personal data via MyScan, Slough Borough Council will be the data controller. The
          service that receives your evidence and personal data will be the data processor.
        </li>
        <li>The personal data we collect from you includes your name, home address, contact details, and occasionally a
          reference or licence number (such as Council Tax reference number)
        </li>
        <li>By submitting your information you are agreeing to the processing of this information by the relevant
          service you choose later.
        </li>
        <li>Your information will be sent securely to the service you choose and will only be used to provide you with
          the council service(s) you have requested.
        </li>
        <li> We may pass your personal data on to our service providers who are contracted to Slough Borough Council in
          the course of dealing with you.
        </li>
        <li>Slough Borough Council will process your information in line with relevant legislation including Data
          Protection Act (DPA) and EU’s General Data Protection Regulation (GDPR).
        </li>
        <li>Our contractors will also process your information in line with relevant legislation including Data
          Protection Act (DPA) and EU’s General Data Protection Regulation (GDPR). They will use the information you
          scan only to fulfil the service they provide to you on our behalf.
        </li>
      </ul>
      <p>
        We will keep your information accurate and up to date and not keep it for longer than is necessary. For further information (including our data protection officer’s contact details and your rights) please see the <a href="https://www.slough.gov.uk/privacy">Privacy Policy</a> on our website, and the relevant Service Privacy Notices therein.
      </p>
    </React.Fragment>
  );
}
